<template>
  <div>
    <div class="videos" v-if="videoList.length > 0">
      <div
        class="videos_item"
        v-for="(item, index) in videoList"
        :key="index"
        @click="start(item)"
      >
        <img :src="item.cover" alt="" />
        <div class="cover">
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <Pagination
      :total="total"
      :pageSize="6"
      @repeater="repeater"
      v-if="videoList.length > 0"
    />
    <Nodata v-else />
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <video autoplay controls :src="videoItem.url">
        您的浏览器不支持 video 。
      </video>
    </el-dialog>
  </div>
</template>
<script>
import { getBannerList } from "@/api/banner";
export default {
  name: "information",
  data() {
    return {
      dialogVisible: false,
      total: 0,
      page: 1,
      videoList: [],
      videoItem: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await getBannerList({
        page: this.page,
        limit: 6,
        banner_type: 6,
      });
      this.videoList = res.data.results;
      this.total = res.data.paging.total;
    },

    start(item) {
      this.videoItem = item;
      this.dialogVisible = true;
    },
    repeater(val) {
      this.page = val;
      this.getData();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.videos {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow: hidden;
  &_item {
    width: 348px;
    height: 260px;
    margin-right: 18px;
    margin-bottom: 18px;
    cursor: pointer;
    position: relative;
    @media only screen and (max-width: 900px) {
      width: 348px;
      height: 260px;
      margin-right: 0;
      margin-bottom: 18px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .cover {
      position: absolute;
      height: 60px;
      background-color: rgba($color: #09090a, $alpha: 0.73);
      left: 0;
      bottom: 0;
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      text-align: left;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      @media only screen and (max-width: 900px) {
        height: 30px;
        font-size: 14px;
        padding: 20px;
      }
      .subTitle {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        @media only screen and (max-width: 900px) {
          font-size: 14px;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn {
  z-index: 99999;
}
::v-deep .el-dialog__headerbtn :hover {
  color: #c6a86c;
}
::v-deep .el-dialog__body {
  padding: 0;
  background: #000;
}
::v-deep .el-dialog__header {
  padding: 0;
}
video {
  width: 100%;
  height: auto;
}
</style>
